module.exports = __webpack_public_path__ + "img/celery.06b90e1c.png";